import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { Container } from '@mui/material';
import Navigation from './components/Navigation';
import CalculationPage from './pages/CalculationPage';
import HistoryPage from './pages/HistoryPage';
import { LimitsProvider } from './utils/limitsContext';

const App: React.FC = () => {
  return (
    <LimitsProvider>
      <Router>
        <Navigation />
        <Container>
          <Routes>
            <Route path="/" element={<CalculationPage />} />
            <Route path="/history" element={<HistoryPage />} />
          </Routes>
        </Container>
      </Router>
    </LimitsProvider>
  );
}

export default App;